import { twMerge } from '@panwds/tailwindcss';
import React from 'react';
/**
 * This component should be used to house similar information or data.
 * It may be used for widgets on a dashboard, data visualizations or data
 * counters, or sections on a page or in a form. These components can be
 * used together to segment the information on a page.
 *
 * Use the CardHeader, CardBody, and CardFooter components for the standard style and behavior. Each are exported from the root:
 *
 * ### Import Guide
 *
 * ```jsx
 * import { Card, CardBody, CardFooter, CardHeader } from '@panwds/react-ui';
 * ```
 */
export function Card({ addClassName, children, dataMetrics, dataTestId, shadow, style = {}, ...passThrough }) {
    const className = twMerge('tw-box-border tw-flex tw-flex-col', 'tw-bg-white dark:tw-bg-gray-1050', 'tw-border-solid tw-border dark:tw-border-0 tw-rounded tw-border-gray-300', 'focus:tw-outline-none focus-visible:tw-ring', shadow && 'hover:tw-shadow-card dark:hover:tw-shadow-card-dark', addClassName);
    return (React.createElement("div", { tabIndex: 0, "data-metrics": dataMetrics, "data-testid": dataTestId || 'card', style: style, className: className, ...passThrough }, children));
}
//# sourceMappingURL=Card.js.map